import { request } from '../@utils'
const Service = {
  getList: async req => await request.post('auth/user/list', { data: req }),
  getDetail: async id => await request.get(`auth/user/info/${id}`),
  getStore: async () => await request.post(`common/store/list`),
  delete: async id => await request.delete(`auth/user/delete/${id}`),
  create: async req => await request.post('auth/user/create', { data: req }),
  update: async req => await request.post('auth/user/update', { data: req }),
  changeStatus: async req =>
    await request.post('auth/user/changeStatus', { data: req }),
  changePassword: async req =>
    await request.post('auth/user/changePassword', { data: req }),
  getAllRoleList: async () => await request.post('auth/role/all'),
}

export default Service

